export const styles = {
  container: {
    color: '#1d2943',
    fontFamily: "'Proxima Nova', sans-serif",
    fontSize: 14,
    borderBottom: '1px solid lightgray',
    paddingBottom: 4,
    marginBottom: 6,
  },
}
